import { defineStore } from 'pinia'

export const useNewCreation = defineStore('new-creation', {
    state() {
        return {
            files: [],
            allUploaded: false
        }
    },

    // getters: {},

    // actions: {}
});
